module.exports = __webpack_public_path__ + "static/media/shreya.9ccc590c.jpeg";